export const blockIconsHomeHeatPump = (
	<span className='material-symbols-outlined'>heat_pump</span>
);
